import {
  jb_button_switch_css_default
} from "./chunk.VU7RG3FO.js";
import {
  ae
} from "./chunk.6PQ7B7BC.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  e,
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-button-switch/jb-button-switch.ts
var JbButtonSwitch = class extends Initiable(r) {
  constructor() {
    super(...arguments);
    this._uniqueId = Math.random().toString(36).substr(2, 9);
  }
  async firstUpdated() {
    this.setAttributes();
    const event = new CustomEvent("button-switch:initialized", {
      detail: { buttonSwitch: this },
      bubbles: true
    });
    this.dispatchEvent(event);
  }
  setAttributes() {
    if (this.name) {
      this._checkbox.setAttribute("name", this.name);
    }
    if (this.initialState) {
      this._checkbox.setAttribute("checked", "checked");
    }
    if (this.disabled) {
      this._checkbox.setAttribute("disabled", "disabled");
    }
  }
  setState(state) {
    if (state) {
      this._checkbox.setAttribute("checked", "checked");
    } else {
      this._checkbox.removeAttribute("checked");
    }
  }
  _change(e2) {
    if (!this.name) {
      return;
    }
    const { checked } = e2.target;
    const event = new CustomEvent("button-switch:changed", {
      detail: { name: this.name, checked },
      bubbles: true
    });
    this.dispatchEvent(event);
    this.requestUpdate();
  }
  _handleKeyboardEvent(evt) {
    if (evt.code === "Enter" || evt.code === "Space") {
      evt.preventDefault();
      this._label.click();
    }
  }
  render() {
    return ke`
      <section
        class=${Rt({
      inverted: this.inverted
    })}
      >
        <label
          data-fly-catcher
          tabindex="${this.disabled ? -1 : 0}"
          @keydown=${this._handleKeyboardEvent}
        >
          <h2 id="label_${this._uniqueId}">${this.label}</h2>
          <div class="switch">
            <input
              tabindex="-1"
              type="checkbox"
              role="switch"
              @change=${this._change}
              .disabled=${this.disabled}
              aria-checked="${this._checkbox?.checked ? "true" : "false"}"
              aria-describedby="${this.description ? `description_${this._uniqueId}` : D}"
              aria-label=${this.ariaLabels?.label ? this.ariaLabels.label : D}
              aria-labelledby="${this.ariaLabels?.label ? D : `label_${this._uniqueId}`}"
            />
            <span
              aria-hidden="true"
              class="state"
              data-on="${this.onText}"
              data-off="${this.offText}"
            ></span>
            <span class="handle"></span>
          </div>
        </label>
        ${this.description ? ke`<jb-richtext
              size="mini"
              id="description_${this._uniqueId}"
              >${ae(this.description)}</jb-richtext
            >` : D}
      </section>
    `;
  }
};
JbButtonSwitch.styles = [reset_css_default, jb_button_switch_css_default];
JbButtonSwitch.shadowRootOptions = { ...r.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Object })
], JbButtonSwitch.prototype, "ariaLabels", 2);
__decorateClass([
  n()
], JbButtonSwitch.prototype, "description", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonSwitch.prototype, "disabled", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonSwitch.prototype, "initialState", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonSwitch.prototype, "inverted", 2);
__decorateClass([
  n()
], JbButtonSwitch.prototype, "label", 2);
__decorateClass([
  n()
], JbButtonSwitch.prototype, "name", 2);
__decorateClass([
  n()
], JbButtonSwitch.prototype, "offText", 2);
__decorateClass([
  n()
], JbButtonSwitch.prototype, "onText", 2);
__decorateClass([
  e("input")
], JbButtonSwitch.prototype, "_checkbox", 2);
__decorateClass([
  e("label")
], JbButtonSwitch.prototype, "_label", 2);
JbButtonSwitch = __decorateClass([
  customElement("jb-button-switch")
], JbButtonSwitch);

export {
  JbButtonSwitch
};
